<template>
    <div class="client-photo-camera">
        <div class="client-photo-select">
            <v-select
                    outlined
                    dense
                    solo
                    v-model="cameraId"
                    :items="cameras"
                    item-text="label"
                    item-value="deviceId"
                    label="Выберите камеру"
                    @change="onCameraChange"
                    hide-details
            />
        </div>
        <div class="client-photo-content">
            <video ref="video" autoplay/>
            <canvas ref="canvas" style="display: none"/>
        </div>
        <div class="client-photo-actions">
            <v-btn @click.prevent="takePhoto" color="success" small fab class="mx-4">
                <v-icon>mdi-camera</v-icon>
            </v-btn>
            <v-btn @click.prevent="closeCamera" color="error" small fab class="mx-4">
                <v-icon>mdi-close-circle</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    export default {
        name   : "WebcamPhoto",
        data() {
            return {
                cameras    : [],
                cameraId   : null,
                localStream: null,
            }
        },
        beforeDestroy() {
            if (this.localStream) {
                this.localStream.getTracks().forEach((track) => {
                    track.stop();
                });
            }
            this.$refs.video.pause();
            this.$refs.video.srcObject = null;
        },
        created() {
            navigator.mediaDevices.getUserMedia({video: true}).then((stream) => {
                navigator.mediaDevices.enumerateDevices()
                         .then((devices) => {
                             this.cameras = devices.filter(device => 'videoinput' === device.kind);
                             this.cameraId = this.cameras.length ? this.cameras[0].deviceId : null;
                             this.onCameraChange();
                         })
                         .catch(() => {
                             this.$toast.error('Приложению не удалось получить доступ к камере');
                         })
                         .finally(() => {
                             stream.getTracks().forEach((track) => {
                                 track.stop();
                             });
                         });
            });
        },
        methods: {
            onCameraChange() {
                if (null === this.cameraId) {
                    return;
                }
                if (this.localStream) {
                    this.localStream.getVideoTracks().forEach((track) => {
                        track.stop();
                    });
                }

                navigator.mediaDevices.getUserMedia({
                    video: {
                        deviceId: {exact: this.cameraId},
                        width   : 1920,
                        height  : 1080
                    }
                }).then((stream) => {
                    this.localStream = stream;
                    this.$refs.video.srcObject = this.localStream;
                    this.$refs.video.play();
                });
            },
            takePhoto() {
                const canvas = this.$refs.canvas;
                const context = canvas.getContext('2d');
                const width = this.$refs.video.videoWidth;
                const height = this.$refs.video.videoHeight;

                canvas.width = width;
                canvas.height = height;
                context.drawImage(this.$refs.video, 0, 0, width, height);

                const data = canvas.toDataURL('image/jpeg');
                if (data) {
                    this.$emit('input', data);
                }
            },
            closeCamera() {
                this.$emit('close');
            }
        }
    }
</script>

<style scoped>

</style>
